
<angular-loader></angular-loader>
<router-outlet></router-outlet>

